import React from 'react'
import { AbstractPanelBar } from './component'
import './styles.css'
import { PanelBarOption } from './types'
import { Upgrade } from '../icons/upgrade'


const upgradeIcon = <Upgrade svgwidth={30} svgheight={30} />

export class DesktopPanelBar extends AbstractPanelBar {

  public render() {
    return <div className="panel-wrap">
      <div className="panel-panelbar">
        <div className="panel-section-header-text panel-indent">
          {this.props.title}
          <span className="header-icon">
            {this.props.headerIcon ? this.props.headerIcon : ''}
          </span>
        </div>
        <div className="panel-detail-text panel-left-indent">
          {this.props.subTitle}
        </div>
        <div className="panel-options">
          {this.outputOptions()}
        </div>
      </div>
    </div>
  }

  private outputOptions() {
    let currentCategory: string = ''

    function _getCategory(item: PanelBarOption) {
      if (currentCategory !== item.category) {
        currentCategory = item.category;
        return <div className="panel-category">{item.category}</div>
      } else {
        return <div></div>
      }
    }

    return this.props.itemList
      .filter((item) => this.showOption(item))
      .map((item: PanelBarOption) => (
        <div key={item.name} className="clickable-item" data-abcd={item.name}>
          {_getCategory(item)}
          {this.isMatch(this.state.selectedItem, item) && (
            <div className="panel-item-selected" onClick={(e: any) => this.handleNav(item)}>
                <div className="icon-wrapper">
                  {item.icon ? item.icon : ''}
                </div>
                <div className="panel-item-text panel-item-text-selected">
                  <div className="item-name">
                    {item.name}
                  </div>
                </div>
              {item.hasFeature === false &&
                <div className="upgrade-icon-wrapper">
                  {upgradeIcon}
                </div>}
            </div>)}
          {!this.isMatch(this.state.selectedItem, item) && (
            <div className="panel-item" onClick={(e: any) => this.handleNav(item)}>
              <div className="icon-wrapper">
                <div className="icon">
                {item.icon ? item.icon : ''}
                </div>
              </div>
              <div className="panel-item-text clickable-item">
                {item.name}
              </div>
              {item.hasFeature === false
                && <div className="upgrade-icon-wrapper">
                  {upgradeIcon}
                </div>}
            </div>)}
        </div>))
  }

  private showOption(option: PanelBarOption) {
    return !option.hide
  }

}
